// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1__JO","cls2":"WorkCard-cls2__7R WorkCard-cls1__JO"};